import { memo } from "react";

import Odd from "src/common/components/odd";
import { usePrevious } from "src/hooks/previous";

import "./style.scss";

interface IProps {
	price: number;
	isBoosted?: boolean;
}

const EventPrice = ({ price, isBoosted }: IProps) => {
	const prevPrice = usePrevious(price);

	const oddChanged = prevPrice && prevPrice !== price;
	const oddChangeClassName = price < (prevPrice || 0) ? "icon-odd-down B-odd-down" : "icon-odd-up B-odd-up";

	return (
		<>
			{isBoosted && <i className={"global-icon icon-boosted-odd boosted-odds"} />}
			<span className="B-betslip-event-price">
				{oddChanged && <i className={`global-icon ${oddChangeClassName}`} />}
				<Odd price={price} />
			</span>
		</>
	);
};

export default memo(EventPrice);
